import type { Locale } from 'date-fns';
import { enUS, el, enGB, de, fr, es, it, nl, pl, ro, bg, tr } from 'date-fns/locale';

/**
 * Map an i18n language code or a full BCP-47 tag to a date-fns locale.
 *
 * Accepts both forms so callers can pass the i18n language (`'el'`) on
 * admin-chrome surfaces and the property locale (`'el-GR'`) on documents.
 * Unrecognised tags fall back to `enUS` rather than throwing mid-render.
 */
const BY_TAG: Record<string, Locale> = {
  'el-gr': el,
  'en-gb': enGB,
  'en-us': enUS,
  'en-ie': enGB,
  'de-de': de,
  'fr-fr': fr,
  'es-es': es,
  'it-it': it,
  'nl-nl': nl,
  'pl-pl': pl,
  'ro-ro': ro,
  'bg-bg': bg,
  'tr-tr': tr,
};

export function resolveDateFnsLocale(language?: string | null): Locale {
  if (!language) return enUS;
  const key = language.toLowerCase();
  const exact = BY_TAG[key];
  if (exact) return exact;
  if (key.startsWith('el') || key === 'greek') return el;
  if (key.startsWith('de')) return de;
  if (key.startsWith('fr')) return fr;
  if (key.startsWith('es')) return es;
  if (key.startsWith('it')) return it;
  if (key.startsWith('nl')) return nl;
  if (key.startsWith('pl')) return pl;
  if (key.startsWith('ro')) return ro;
  if (key.startsWith('bg')) return bg;
  if (key.startsWith('tr')) return tr;
  return enUS;
}
